module.exports = __webpack_public_path__ + "static/media/packed_ct.a1a221f0.png";